var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoChevronRightOrange = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "12px",
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/24x24/ico_chevron_right_small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "35-Sixtbook_directly_to_A",
    transform: "translate(-917.000000, -218.000000)",
    fill: "#FF5000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "center",
    transform: "translate(430.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(30.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link/desktop/small/default/orange",
    transform: "translate(449.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_chevron_right_small"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "shape",
    points: "8.69 15.7935534 12.4828932 12.0006602 8.69 8.20776695 10.1042136 6.79355339 15.3113203 12.0006602 10.1042136 17.207767"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoChevronRightOrange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_chevron_right_orange.d41ecbe56fbd5b226bf36c33044a8c16.svg";